import elementResizeDetectorMaker from "element-resize-detector"

const addListener = component => {
  // eslint-disable-next-line no-param-reassign
  component._erd = elementResizeDetectorMaker({
    strategy: `scroll`,
  })

  // eslint-disable-next-line no-param-reassign
  component._erdWidth = component.container.offsetWidth

  component._erd.listenTo(component.container, element => {
    const width = element.offsetWidth

    if (component._erdWidth !== width) {
      component.resize(component.props)
      // eslint-disable-next-line no-param-reassign
      component._erdWidth = width
    }
  })
}

const removeListener = component => {
  component._erd.uninstall(component.container)
}

export default { addListener, removeListener }
